import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_82ce35da: FaireBrandEntity = {
  token: "b_82ce35da",
  type: "brand",
  name: "tag",
  avatarUrl:
    "https://cdn.faire.com/fastly/71ac9fe848415d67a6648445f4dc9503a8a61089843af0623a5deff7a1ba4b2e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/632c939396318db0ebfc811a110cc688ccaef244c1037aae45dd9478ab5b22ed.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/71ac9fe848415d67a6648445f4dc9503a8a61089843af0623a5deff7a1ba4b2e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/632c939396318db0ebfc811a110cc688ccaef244c1037aae45dd9478ab5b22ed.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 350,
  rating: 4.6,
  reviewCount: 138,
  isInsider: true,
  description:
    "For over five decades, tag has been a leading lifestyle brand headquartered in Chicago. We design beautiful and functional products for every corner of the home, from indoors to garden and outdoor escapes.  We offer both seasonal accents and everyday essentials, all crafted to inspire connection and enhance moments with loved ones.  Our collections seamlessly integrate into any decor blending form with function. Driven by innovation, we strive to create products that spark joy and elevate everyday living.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:08.172Z",
    importedBy: "entity-db-cli",
  },
};
